export enum PriorityEnum{
    HIGH = 'HIGH',
    MEDIUM='MEDIUM',
    LOW='LOW'   
  }
  export const PriorityEnumDisplay = [
    { name: "HIGH", displayVal:'HIGH'},
    { name:'MEDIUM', displayVal:'MEDIUM'},
    { name:'LOW', displayVal:'LOW'},

]